/*
  Pricing page for FullStack.cash
*/

import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Container, Row, Col, Table } from 'react-bootstrap'

function Pricing () {
  return (
    <>
      <Helmet>
        <title>Pricing - FullStack.cash</title>
      </Helmet>

      <Container className='py-5'>
        <Row>
          <Col>
            <h2 className='mb-4'>Private Infrastructure</h2>
            <p>
              Our larger clients have us host private, customized
              infrastructure for them. Each instance is
              isolated so that only the client and the client's users have
              access to the resource.
            </p>
            <p>
              Recommended maximum capacity is 2 million API requests per day per
              instance of infrastructure. Multiple instances can be connected
              in parallel to scale infinitely to higher loads. Prices are in
              USD.
            </p>

            <Table striped bordered hover className='mt-4'>
              <thead>
                <tr>
                  <th>Infrastructure</th>
                  <th>Price per Month</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>bch-api REST API</td>
                  <td>$30</td>
                </tr>
                <tr>
                  <td>Bitcoin Cash (BCHN) Full Node</td>
                  <td>$75</td>
                </tr>
                <tr>
                  <td>eCash (XEC) Full Node</td>
                  <td>$75</td>
                </tr>
                <tr>
                  <td>Fulcrum ElectrumX Indexer</td>
                  <td>$50</td>
                </tr>
                <tr>
                  <td>SLP Indexer</td>
                  <td>$50</td>
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default Pricing
